var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C2033",
    width: 52,
    height: 52,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4 12.3076H17.8C16.6 12.3076 15.5 13.2922 15.5 14.5722V27.963C15.5 29.1445 16.5 30.2276 17.8 30.2276H37.4C38.6 30.2276 39.7 29.243 39.7 27.963V14.5722C39.6 13.2922 38.6 12.3076 37.4 12.3076ZM35.1 25.7968H20V16.7384H35.1V25.7968Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8008 19.4954L55.2008 12.0123C54.3008 11.1262 52.9008 11.1262 52.0008 12.0123C51.1008 12.8985 51.1008 14.2769 52.0008 15.1631L55.1008 18.2154V25.1077C55.1008 26.2892 56.1008 27.3723 57.4008 27.3723H58.9008V42.24H54.0008V30.3261C54.0008 29.1446 53.0008 28.0615 51.7008 28.0615H46.3008V11.8154C46.3008 8.46769 43.5008 5.6123 40.0008 5.6123H15.0008C11.6008 5.6123 8.70078 8.36923 8.70078 11.8154V54.4492H5.60078C4.40078 54.4492 3.30078 55.4338 3.30078 56.7138C3.30078 57.9938 4.30078 58.9785 5.60078 58.9785H49.3008C50.5008 58.9785 51.6008 57.9938 51.6008 56.7138C51.6008 55.4338 50.6008 54.4492 49.3008 54.4492H46.2008V32.5908H49.4008V44.5046C49.4008 45.6862 50.4008 46.7692 51.7008 46.7692H61.1008C62.3008 46.7692 63.4008 45.7846 63.4008 44.5046V21.0708C63.4008 20.48 63.2008 19.8892 62.8008 19.4954ZM13.3008 54.4492V11.8154C13.3008 10.8308 14.1008 10.0431 15.1008 10.0431H40.1008C41.1008 10.0431 41.9008 10.8308 41.9008 11.8154V54.4492H13.3008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.a01e9b1c6234ee20577119e45ee65045.svg";
export { ForwardRef as ReactComponent };